// @ts-nocheck
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { imageConfig } from "../../../../config/config";
import { getText } from "../../../../utils/util";
import "./index.css";

export default function ListPage({ addressList, delAddress, coinList }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  //adderss类
  const getAddressNodes = () => {
    const nodes = [];
    for (const data of addressList) {
      const node = (
        <div key={data.id} className="bg-neutral-800 rounded-xl mb-4 p-4 shadow-md border border-neutral-700 flex items-center relative">
          <div className="w-12 h-12 md:w-14 md:h-14 flex-shrink-0 rounded-full overflow-hidden">
            <img
              src={imageConfig.baseImageUrl + getLogo(data.name)}
              draggable="true"
              className="w-full h-full object-cover"
              alt={data.name}
            />
          </div>
          <div className="flex-1 mx-4">
            <div className="mb-1 text-neutral-300">
              <span className="text-neutral-400 text-sm">{translate(getText("幣種："))}</span>
              <span className="text-primary font-medium ml-1">{`${data?.name.toUpperCase()}${
                data.czline ? `-${data.czline}`.toUpperCase() : ""
              }`}</span>
            </div>
            <div className="mb-1 text-neutral-300">
              <span className="text-neutral-400 text-sm">{translate(getText("地址："))}</span>
              <span className="text-white text-sm font-light break-all">{data.addr}</span>
            </div>
            <div className="text-neutral-300">
              <span className="text-neutral-400 text-sm">{translate(getText("日期："))}</span>
              <span className="text-neutral-300 text-sm">{data?.addtime}</span>
            </div>
          </div>
          <button 
            className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full hover:bg-neutral-700 transition-colors"
            onClick={() => delAddress(data.id)}
          >
            <svg className="w-5 h-5 text-danger" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="currentColor"/>
            </svg>
          </button>
        </div>
      );
      nodes.push(node);
    }
    return nodes;
  };

  const getLogo = (name) => {
    for (const data of coinList) {
      if (name == data.name) {
        return data.img;
      }
    }
    return "";
  };
  return (
    <div className="p-4 pb-20">
      <div className="max-w-lg mx-auto">
        {getAddressNodes()}
        <button
          className="w-full py-3 mt-6 bg-gradient-primary rounded-xl text-white font-medium shadow-md hover:opacity-90 transition-opacity flex items-center justify-center"
          onClick={() => navigate("/addressadd")}
        >
          <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor"/>
          </svg>
          {translate(getText("添加錢包地址"))}
        </button>
      </div>
    </div>
  );
}
